import * as ng from 'angular';
import AppConstants from '../../gorillaboy/AppConstants';

import './ingressModal.html';
import {RootScope} from "../../types/angular-types";
import Features from "../../feature-manager/Features";

interface AppOption {
    optionId: string;
    text: string;
    link?: string;
    onClick?: Function;
}

interface AppInfo {
    title: string;
    description: string;
    image: string;
    imageLink?: string;
    onClick?: Function;
    openInNewWindow?: boolean;
    options: AppOption[];
}

export interface IScope extends ng.IScope {
    apps: AppInfo[],
}

angular.module('GorillaBoy')
    .controller('ingressModalCtrl', [
        '$scope',
        '$rootScope',
        '$log',
        '$translate',
        '$location',
        'authenticatedUser',
        'CompanionService',
        function ingressModalCtrl($scope: IScope, $rootScope: RootScope, $log: ng.ILogService, $translate: ng.translate.ITranslateService, $location: ng.ILocationService, authenticatedUser, CompanionService) {
            // Initialization
            const approvalAppLink: string = getAppLink('approvals');
            const meetingAppLink: string = getAppLink('meetings');
            const migrationAppLink: string = getAppLink('migrations');
            const chatbotAppLink: string = getAppLink('chatbot');
            const classificationAppLink: string = getAppLink('classifications');
            var userInfo = authenticatedUser.getUserInfo();

            $scope.apps = [{
                title: $translate.instant('INGRESS_MODEL_COMPANION_TITLE'),
                description: $translate.instant('INGRESS_MODEL_COMPANION_DESCRIPTION'),
                image: 'ingress-modal-image-companion',
                options: [{
                    optionId: 'download_companion_pc',
                    text: $translate.instant('INGRESS_MODEL_OPTION_PC'),
                    link: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/windows/latest_version/Amazon WorkDocs Companion.msi',
                }, {
                    optionId: 'download_companion_mac',
                    text: $translate.instant('INGRESS_MODEL_OPTION_MAC'),
                    link: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/mac/latest_version/Amazon WorkDocs Companion.pkg',
                }]
            }, {
                title: $translate.instant('INGRESS_MODEL_DRIVE_TITLE'),
                description: $translate.instant('INGRESS_MODEL_DRIVE_DESCRIPTION'),
                image: 'ingress-modal-image-drive',
                options: [{
                    optionId: 'download_drive_pc',
                    text: $translate.instant('INGRESS_MODEL_OPTION_PC'),
                    link: 'https://d3f2hupz96ggz3.cloudfront.net/win/AWSWorkDocsDriveClient.msi',
                }, {
                    optionId: 'download_drive_mac_silicon',
                    text: $translate.instant('INGRESS_MODEL_OPTION_MAC_CONSOLIDATED'),
                    link: 'https://d3f2hupz96ggz3.cloudfront.net/mac_v2/AmazonWorkDocsDrive.pkg',
                }]
            }, {
                title: $translate.instant('INGRESS_MODEL_MOBILE_TITLE'),
                description: $translate.instant('INGRESS_MODEL_MOBILE_DESCRIPTION'),
                image: 'ingress-modal-image-mobile',
                options: [{
                    optionId: 'download_mobile_android',
                    text: $translate.instant('INGRESS_MODEL_OPTION_ANDROID'),
                    link: 'https://play.google.com/store/apps/details?id=com.amazon.zocalo',
                }, {
                    optionId: 'download_mobile_ios',
                    text: $translate.instant('INGRESS_MODEL_OPTION_IOS'),
                    link: 'https://itunes.apple.com/us/app/amazon-workdocs/id878419553?ls=1&mt=8',
                }]
            }];
            // Definition of scope methods
            if (!$rootScope.isFeatureEnabled(Features.UI.APPROVAL_V2_DISABLED)) {
                $scope.apps.push({
                    title: $translate.instant('INGRESS_MODEL_APPROVAL_TITLE'),
                    description: $translate.instant('INGRESS_MODEL_APPROVAL_DESCRIPTION'),
                    image: 'ingress-modal-image-approvals',
                    imageLink: approvalAppLink,
                    openInNewWindow: true,
                    options: [{
                        optionId: 'launch_approvals_app',
                        text: $translate.instant('INGRESS_MODEL_OPTION_LAUNCH'),
                        link: approvalAppLink,
                    }]
                });
            }
            if($rootScope.isFeatureEnabled(Features.UI.MEETINGS)) {
                $scope.apps.push({
                    title: $translate.instant('INGRESS_MODEL_MEETING_TITLE'),
                    description: $translate.instant('INGRESS_MODEL_MEETING_DESCRIPTION'),
                    image: 'ingress-modal-image-meetings',
                    imageLink: meetingAppLink,
                    openInNewWindow: true,
                    options: [{
                        optionId: 'launch_meetings_app',
                        text: $translate.instant('INGRESS_MODEL_OPTION_LAUNCH'),
                        link: meetingAppLink,
                    }]
                });
            }
            if (userInfo.Administrator && !$rootScope.isFeatureEnabled(Features.UI.MIGRATIONS_DISABLED)) {
                $scope.apps.push({
                    title: $translate.instant('INGRESS_MODEL_MIGRATION_TITLE'),
                    description: $translate.instant('INGRESS_MODEL_MIGRATION_DESCRIPTION'),
                    image: 'ingress-modal-image-migrations',
                    imageLink: migrationAppLink,
                    openInNewWindow: true,
                    options: [{
                        optionId: 'launch_migrations_app',
                        text: $translate.instant('INGRESS_MODEL_OPTION_LAUNCH'),
                        link: migrationAppLink,
                    }]
                });
            }

            // TODO Chatbot to use same icon/style as meetings until new thumbnail is created by Neil.
            if($rootScope.isFeatureEnabled(Features.UI.CHATBOT)) {
                $scope.apps.push({
                    title: $translate.instant('INGRESS_MODEL_CHATBOT_TITLE'),
                    description: $translate.instant('INGRESS_MODEL_CHATBOT_DESCRIPTION'),
                    image: 'ingress-modal-image-meetings',
                    imageLink: chatbotAppLink,
                    openInNewWindow: true,
                    options: [{
                        optionId: 'launch_chatbot_app',
                        text: $translate.instant('INGRESS_MODEL_OPTION_LAUNCH'),
                        link: chatbotAppLink,
                    }]
                });
            }

            if ($rootScope.isFeatureEnabled(Features.UI.CLASSIFICATIONS)) {
                $scope.apps.push({
                    title: $translate.instant('INGRESS_MODEL_CLASSIFICATION_TITLE'),
                    description: $translate.instant('INGRESS_MODEL_CLASSIFICATION_DESCRIPTION'),
                    image: 'ingress-modal-image-classifications',
                    imageLink: classificationAppLink,
                    openInNewWindow: true,
                    options: [{
                        optionId: 'launch_classifications_app',
                        text: $translate.instant('INGRESS_MODEL_OPTION_LAUNCH'),
                        link: classificationAppLink,
                    }]
                });
            }

            if($rootScope.isFeatureEnabled(Features.UI.COMPANION_DOWNLOAD_TERMINATION_SWITCH)){
                $scope.apps = $scope.apps.slice(1)
            }

            // Definition of private methods
            function getAppLink(pathPrefix:string): string {
                const path = window.location.pathname;
                const approvalAppLinkPrefix = path.substring(0,path.lastIndexOf("/")); // take anything before the last "/"
                return approvalAppLinkPrefix + `/${pathPrefix}/index.html`;
            }
        }
    ]);
